import React from 'react'
import { useSelector } from 'react-redux'
import { CSidebar, CSidebarBrand, CSidebarNav } from '@coreui/react'
import { AppSidebarNav } from '../../components/AppSidebarNav'
import CIcon from '@coreui/icons-react'
import { cilEnvelopeLetter } from '@coreui/icons'
import { CNavItem, CNavTitle } from '@coreui/react'
import xnabrand from 'src/assets/xnabrand/feracloud_logo_text.png'
import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

const RequestAccessSidebar = () => {
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)

  const requestAccessNavItems = [
    {
      component: CNavTitle,
      name: 'Access',
    },
    {
      component: CNavItem,
      name: 'Request Access',
      to: '/request_access',
      icon: <CIcon icon={cilEnvelopeLetter} customClassName="nav-icon" />,
    },
  ]

  return (
    <CSidebar position="fixed" unfoldable={unfoldable} visible={sidebarShow}>
      <CSidebarBrand className="d-none d-md-flex" to="/">
        <img className="sidebar-brand-full" src={xnabrand} height={35} />
      </CSidebarBrand>
      <CSidebarNav>
        <div className="navbar-container">
          <SimpleBar>
            <AppSidebarNav items={requestAccessNavItems} />
          </SimpleBar>
        </div>
      </CSidebarNav>
      <div className="d-none d-lg-flex" />
    </CSidebar>
  )
}

export default RequestAccessSidebar
